{
  "title": "आपके स्थान तक पहुंच की अनुमति दें?",
  "body": "आपके स्थान तक पहुंच की अनुमति देकर हम सुनिश्चित कर सकते हैं कि आप चेक-इन के लिए सुविधा में पहुंचे हैं",
  "disagree": "असहमत",
  "agree": "सहमत"
}
